import { post } from './instance-api';

type UserBasic = {
    address: string;
};

export const getGame = async ({ address }: UserBasic) => {
    const response = await post('/nfts', {
        address,
    }).catch((error) => {
        return [];
    });

    return response;
};

export const getClaimTime = async ({ address }: UserBasic) => {
    const response = await post('/next_claim', {
        address,
    }).catch((error) => {
        return {};
    });

    return response;
};

export const collectNFT = async ({ address }: UserBasic) => {
    const response = await post('/collect_nft', {
        address,
    }).catch((error) => {
        return {};
    });

    return response;
};
